// Zanzibar tours/excursions — relocated out of the ZanzibarSafari.js component
// so it can be a single source consumed by the page, the /safaris hub
// (via data/destinations), and the AI planner's knowledge base.
export const tours = [
  {
    id: 1,
    title: "Safari Blue + Sunset Dhow Cruise",
    category: "Full-Day Adventure",
    duration: "8-10 hours",
    groupSize: "2-12 people",
    rating: 4.9,
    reviews: 156,
    price: 125,
    image: "https://images.unsplash.com/photo-1579597242496-0e57179802c1?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTB8fHNhZmFyaSUyMGJsdWUlMjB6YW56aWJhcnxlbnwwfHwwfHx8MA%3D%3D",
    highlights: [
      "Menai Bay marine conservation area",
      "Snorkeling at vibrant coral reefs",
      "Seafood BBQ lunch with lobster",
      "Romantic sunset dhow cruise"
    ],
    description: "Perfect mix of adventure, relaxation, and breathtaking ocean views combining morning Safari Blue excursion with evening sunset cruise.",
    bestFor: "Adventure seekers and romance"
  },
  {
    id: 2,
    title: "Stone Town + Spice Tour + Prison Island",
    category: "Cultural & Historical",
    duration: "6-8 hours",
    groupSize: "2-15 people",
    rating: 4.8,
    reviews: 203,
    price: 85,
    image: "https://images.unsplash.com/photo-1693891036703-dc12bebb3d11?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8N3x8cHJpc29uJTIwaXNsYW5kJTIwemFuemliYXJ8ZW58MHx8MHx8fDA%3D",
    highlights: [
      "UNESCO World Heritage Stone Town",
      "Historic slave market and Sultan's Palace",
      "Authentic spice farm experience",
      "Giant Aldabra tortoises on Prison Island"
    ],
    description: "Journey through Zanzibar's rich history, from ancient Stone Town to aromatic spice farms and the famous Prison Island.",
    bestFor: "History & culture enthusiasts"
  },
  {
    id: 3,
    title: "Dolphin Tour + Jozani Forest + Nungwi",
    category: "Nature & Wildlife",
    duration: "7-9 hours",
    groupSize: "2-10 people",
    rating: 4.7,
    reviews: 89,
    price: 95,
    image: "https://images.unsplash.com/photo-1694960679151-8b2da9099d0c?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8am96YW5pJTIwZm9yZXN0fGVufDB8fDB8fHww",
    highlights: [
      "Swimming with wild dolphins",
      "Red Colobus monkey sightings",
      "Mangrove boardwalk exploration",
      "Sea turtle conservation center"
    ],
    description: "Experience Zanzibar's incredible wildlife from playful dolphins to endangered monkeys in their natural habitats.",
    bestFor: "Nature lovers and families"
  },
  {
    id: 4,
    title: "Mnemba Atoll Snorkeling Adventure",
    category: "Marine Experience",
    duration: "6-7 hours",
    groupSize: "2-8 people",
    rating: 4.9,
    reviews: 134,
    price: 110,
    image: "https://images.unsplash.com/photo-1564501049412-61c2a3083791?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1932&q=80",
    highlights: [
      "World-class snorkeling at Mnemba Atoll",
      "Sea turtles and tropical fish",
      "Pristine coral reefs",
      "Sandbank relaxation"
    ],
    description: "Dive into crystal-clear waters at Zanzibar's premier snorkeling destination with abundant marine life.",
    bestFor: "Snorkelers and water enthusiasts"
  },
  {
    id: 5,
    title: "Romantic Spice Tour + Sunset Cruise",
    category: "Romantic Experience",
    duration: "5-6 hours",
    groupSize: "2-6 people",
    rating: 4.8,
    reviews: 78,
    price: 140,
    image: "https://images.unsplash.com/photo-1575992042651-e35f5a391252?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OHx8c3Vuc2V0JTIwemFuemliYXJ8ZW58MHx8MHx8fDA%3D",
    highlights: [
      "Private spice farm tour",
      "Champagne sunset cruise",
      "Candlelit beach dinner",
      "Aromatic spice tasting"
    ],
    description: "An intimate journey through Zanzibar's spice heritage culminating in a romantic sunset cruise and private dinner.",
    bestFor: "Couples and honeymooners"
  }
];
